import { State } from '../machine';

export enum Section {
  CompanyInformation = 'companyInformation',
  SupportingDocuments = 'supportingDocuments',
  Plan = 'plan',
  Review = 'review',
}

export const STATE_TO_SECTION: Record<State, Section | null> = {
  [State.INIT]: null,
  [State.ABORT]: null,
  [State.DONE]: null,

  [State.ABORT_APPLICATION]: null,

  [State.COMPANY_COMPLIANCE]: Section.CompanyInformation,

  [State.OBJET_SOCIAL]: Section.CompanyInformation,
  [State.SEND_OBJET_SOCIAL]: Section.CompanyInformation,
  [State.SASU_CREATION_LANDBOT]: Section.CompanyInformation,
  [State.SASU_CREATION_LANDBOT_PENDING]: Section.CompanyInformation,
  [State.SASU_CREATION_LANDBOT_SUCCESS]: Section.CompanyInformation,
  [State.PERSONAL_COMPLIANCE]: Section.CompanyInformation,
  [State.SASU_CREATION_CREATE]: Section.CompanyInformation,
  [State.SASU_CREATION_EU_BANK_ACCOUNT]: Section.CompanyInformation,
  [State.USER_PROFILE_SEND]: Section.CompanyInformation,
  [State.BENEFICIARIES_DOCS]: Section.SupportingDocuments,
  [State.VERIFICATION]: Section.SupportingDocuments,
  [State.USER_AGREEMENT]: Section.SupportingDocuments,
  [State.SASU_CREATION_AGREEMENT]: Section.SupportingDocuments,

  [State.SASU_CREATION_PLAN_CHOICE]: Section.Plan,
  [State.SASU_CREATION_SUBMIT_APPLICATION]: Section.Plan,

  [State.SASU_CREATION_NEXT_STEPS]: Section.Review,
  [State.APPLICATION_FOLLOW_UP]: Section.Review,
  [State.DOWNLOAD_SHINE_MESSAGE_SENT]: Section.Review,
};

export const SECTIONS = [
  Section.CompanyInformation,
  Section.SupportingDocuments,
  Section.Plan,
  Section.Review,
] as const;
